import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from 'sonner';
import { PriceTicker } from './components/PriceTicker';
import { Header } from './components/Header';
import { Footer } from './components/Footer';

import Home from './pages/Home';
import StartHere from './pages/StartHere';
import News from './pages/News';
import Tutorials from './pages/Tutorials';
import Articles from './pages/Articles';
import ArticlePage from './pages/ArticlePage';
import Tools from './pages/Tools';
import Donate from './pages/Donate';
import About from './pages/About';
import Contact from './pages/Contact';
import PrivacyPolicy from './pages/PrivacyPolicy';
import AdminPanel from './pages/AdminPanel';

function App() {
  return (
    <div className="App font-manrope">
      <BrowserRouter>
        <PriceTicker />
        <Header />
        <main className="min-h-screen">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/comece-aqui" element={<StartHere />} />
            <Route path="/noticias" element={<News />} />
            <Route path="/noticias/:slug" element={<ArticlePage />} />
            <Route path="/tutoriais" element={<Tutorials />} />
            <Route path="/tutoriais/:slug" element={<ArticlePage />} />
            <Route path="/artigos" element={<Articles />} />
            <Route path="/artigos/:slug" element={<ArticlePage />} />
            <Route path="/ferramentas" element={<Tools />} />
            <Route path="/doar" element={<Donate />} />
            <Route path="/sobre" element={<About />} />
            <Route path="/contato" element={<Contact />} />
            <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
            <Route path="/admin" element={<AdminPanel />} />
          </Routes>
        </main>
        <Footer />
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;
